<template>
  <s-modal
    v-model:open="open"
    :title="t('points')"
    :tagline="t('tagline')"
    :confirm="{
      label: t('actions.applyAll'),
      icon: 'check',
    }"
    confirmable
    cancellable
    @confirm="apply"
    width="md"
  >
    <template #content>
      <p class="mb-2">
        {{ t('description') }}
      </p>
      <s-input-field
        id="attempts"
        :label="t('points')"
        v-model="form.points"
        type="number"
        min="0"
        :suffix="t('points')"
      />
      <p v-if="mixed" class="text-sm text-gray-500 mt-2">
        {{ t('warning.mixed') }}
      </p>
    </template>
  </s-modal>
</template>
<script setup lang="ts">
import SModal from '../../../design-system/SModal.vue';
import {reactive, ref, watch} from 'vue';
import SInputField from '../../../design-system/SInputField.vue';
import {CreateTaskAssignmentDto} from '../task-assignment-factory';
import {useI18n} from 'vue-i18n';

const open = defineModel('open', {default: false});
const taskAssignments = defineModel('taskAssignments', {default: [] as CreateTaskAssignmentDto[]});

const form = reactive({
  points: 1,
});

const mixed = ref(false);

watch(open, (isOpen) => {
  if (isOpen) {
    const points = taskAssignments.value[0]?.pointValue || 1;

    mixed.value = !taskAssignments.value.every(({pointValue}) => pointValue === points);

    form.points = mixed.value ? 1 : points;
  }
});

const apply = () => {
  taskAssignments.value.forEach((ta) => {
    ta.pointValue = form.points;
  });
};

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "tagline": "Editing all tasks",
    "actions.applyAll": "Apply to all Tasks",
    "description": "Set how many points each task is worth on the assignment.",
    "warning.mixed": "Note: Tasks that have different points will be set to the same value."
  },
  "fr": {
    "tagline": "Édition de toutes les tâches",
    "actions.applyAll": "Appliquer à toutes les tâches",
    "description": "Définissez combien de points chaque tâche vaut dans l'affectation.",
    "warning.mixed": "Remarque : Les tâches qui ont des points différents seront définies sur la même valeur."
  }
}
</i18n>
